module.exports = __webpack_public_path__ + "img/11 Winter u. Herb 2.jpg";